import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';
import {
    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    translate,
} from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { get } from "core-js/core/dict";

export default function List() {
    const [, set_dados] = useState(null);
    const dados = useRef(null);
    const permissions = useRef(null);

    const [document_state_list, set_document_state_list] = useState([])

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const active = useRef(null);
    const active_raw = useRef(null);

    { console.log('active', active.current) }
    { console.log('active_raw', active_raw.current) }

    const order_array = (array) => {

        return array.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // ignore upper and lowercase
            const nameB = b.name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        });

    }

    const get_info = async () => {
        await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/active`)
            //await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404
            )
    }


    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            set_dados(active.current = [])

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em edição'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]

            const fetch_maintenance_actives = async (type) => {

                let res = await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/${type}`)
                let result = []
                if (res.data !== undefined) {
                    for await (let el of res.data) {
                        //console.log('el', el)
                        let aux = {
                            id: el.id,
                            name: translate(el.info.title, 'pt'),

                            cod: el.info.tag,
                            brand: el.info.settings.storage_brand,
                            model: el.info.settings.storage_model,
                            serie: el.info.settings.storage_serie,
                            local: el.info.settings.storage_local,
                        }
                        console.log('aux', aux)
                        result.push(aux)
                    }
                }

                return result

            }

            const get_attr = async () => {
                let res_1 = await fetch_maintenance_actives('active')
                if (res_1.length > 0) {
                    res_1 = order_array(res_1)

                    let res_aux_1 = []
                    for await (let el of res_1) {
                        res_aux_1.push({
                            id: el.id,
                            label: el.name,
                        })
                    }
                    set_dados(active.current = res_aux_1)
                    set_dados(active_raw.current = res_1)

                    /* 
                    if (dados.current.info?.equipment?.id !== undefined && dados.current?.info?.equipment?.id !== null && dados.current?.info?.equipment?.id !== '') {
                        const selected = res_1?.find(el => parseInt(el.id) === parseInt(dados.current?.info?.equipment?.id))
                        setSelectedEquipment(selected || null);
                    }
                    */
                }

                setLoading(false);

                return true

            }

            set_document_state_list(aux_document_state)

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            get_attr()
            setLoading(false)

        })()

    }, [pathname, active_raw]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    { console.log('data', data) }

    const columns = [
        {
            name: language[lang].field_tag,
            selector: 'info.tag',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_name,
            selector: 'info.name',
            width: '23% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_brand,
            selector: 'info.equipment.brand',
            width: '20% !important',
            minWidth: '200px !important',
            cell: row => 
                <span>
                    {row?.info?.equipment?.brand !== undefined ? row.info.equipment.brand : ''}
                    {row?.info?.equipment?.model !== undefined ? ' ' + row.info.equipment.model : ''}
                    {row?.info?.equipment?.serie !== undefined ? ' ' + row.info.equipment.serie : ''}
                </span>
            ,
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_storage_fab_year,
            selector: 'info.settings.ano_de_aquisicao',
            width: '10% !important',
            minWidth: '200px !important',
            cell: row => (
                <span style={{
                    fontFamily: 'monospace',
                    fontVariantNumeric: 'tabular-nums',
                }}>
                {row?.info?.settings?.ano_de_aquisicao !== undefined ? row.info.settings.ano_de_aquisicao.split('T')[0] : ''}
            </span>
            ),
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_storage_local,
            selector: 'info.settings.storage_local',
            width: '12% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].man_tipo,
            selector: row => parseInt(row.info.settings.repair_type),
            cell: row => {
                const repairType = parseInt(row.info.settings.repair_type);
                if (repairType === 13) return 'C';
                if (repairType === 12) return 'P';
                return "";
            },
            width: '8%',
            minWidth: '100px',
            sortable: true,
            center: true,
        },
        /* 
        {
            name: language[lang].numero_manutencao,
            selector: 'info.settings.storage_local',
            width: '10% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        */
        {
            name: language[lang].table_data_manutencao,
            selector: 'info.responsable.edit.execution',
            width: '10% !important',
            minWidth: '200px !important',
            cell: row => (
                <span style={{
                    fontFamily: 'monospace',
                    fontVariantNumeric: 'tabular-nums',
                }}>
                {row?.info?.responsable?.edit?.execution !== undefined ? row.info.responsable.edit.execution.split('T')[0] : ''}
            </span>
            ),
            sortable: true,
            center: true,
        },     
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '7% !important',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };


    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8 d-none">
                                        <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                            to={{ pathname: endpoints.regist }}
                                            style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                        >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}